import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { AssetOrderingOptions, GetStakingOverviewGQLService, Order } from "@gql/staking";
import { catchError, map } from "rxjs/operators";
import { ExceptionsService } from "@core-services/exceptions.service";
import { InfoService } from "@core-services/info.service";
import { StakingOverviewState } from "@modules/staking/domain/entities/staking-overview-state.model";
import { StakingHelperService } from "@modules/staking/domain/+state/utility/staking-helper.service";
import { PortfolioAssetDetails } from "@modules/portfolio/domain/entities/portfolio-overview.model";

@Injectable()
export class StakingOverviewRemote {
	public constructor(
		private readonly stakingOverviewService: GetStakingOverviewGQLService,
		private readonly stakingHelperService: StakingHelperService,
		private readonly exceptionsService: ExceptionsService,
		private readonly infoService: InfoService
	) {}

	public fetchOverviewInfo(ownedAssets?: PortfolioAssetDetails[]): Observable<StakingOverviewState> {
		return this.stakingOverviewService
			.watch(
				{
					order: { orderBy: AssetOrderingOptions.YearlyInterest, order: Order.Desc }
				},
				{ fetchPolicy: "network-only" }
			)
			.valueChanges.pipe(
				map(({ data }) => this.stakingHelperService.adaptOverviewResponse(data, ownedAssets)),
				catchError(this.exceptionsService.extractGqlErrorAndRethrow),
				catchError((error) => {
					this.infoService.handleApiError(error);
					return throwError(error);
				})
			);
	}
}
